




















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class MiniStatistic extends Vue {
	@Prop()
	icon: string
	@Prop()
	title: string
	@Prop()
	subTitle: string
	@Prop()
	color: string

	background: string = 'grey darken-4'
}
